<template>
    <div id="container"></div>
</template>

<script>
	//import '@/lib-flexible/flexible.js'
/* import Amap from 'Amap' */
export default {
	data(){
		return{
			cccc:'en',
		}
	},
  mounted () {
    this.init()
  },
  methods: {
    init () {
		/* {lng:110.343116,lat:25.274862} */
     var map = new AMap.Map('container', {
             resizeEnable: true,
             center: [110.336512,25.269241],
             zoom: 15,
			 lang:this.cccc
         });
     
         var marker = new AMap.Marker({
             position: map.getCenter(),
             icon: '//a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-default.png',
             anchor:'bottom-center',
             offset: new AMap.Pixel(0, 0)
         });
     
         marker.setMap(map);
     
         // 设置鼠标划过点标记显示的文字提示
         marker.setTitle('我是marker的title');
     
         // 设置label标签
         // label默认蓝框白底左上角显示，样式className为：amap-marker-label
         marker.setLabel({
            direction:'right',
            offset: new AMap.Pixel(10, 0),  //设置文本标注偏移量
			content: this.cccc, //设置文本标注内容桂林啄木鸟医疗器械
         });
    }
  }
}
</script>
<style>
	html,
	body,
	#container {
	    width: 1920px;
	    height:800px;
	}
</style>